import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {SidebarService} from '~core/components/sidebar/sidebar.service';
import {Club, SidebarOptions} from '~core/models';
import {NavigationService, ScreenSizeService, StorageService} from '~core/services';

/**
 * This component is responsible for the import of customers from CSV files.
 */
@UntilDestroy()
@Component({
  selector: 'app-import-customer',
  templateUrl: 'import-customer.component.html',
  styleUrls: ['import-customer.component.scss']
})

export class ImportsComponent implements OnDestroy {
  public isOpen: boolean = false;
  public selectedClub: Club;
  public selectedDataType: string = 'null';
  @ViewChild('fileInput') public fileInput: ElementRef;

  constructor(
    public sidebarService: SidebarService,
    public navigationService: NavigationService,
    public storage: StorageService,
    private screenSizeService: ScreenSizeService,
  ) {
    this.storage.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
    this.navigationService.setCurrentPage('imports');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'imports']);

    if (this.screenSizeService.screenSize === 'desktop') {
      this.sidebarService.setSidebar(new SidebarOptions(true, true));
    } else {
      this.sidebarService.setSidebar(new SidebarOptions(false, true));
    }
  }

  public ngOnDestroy(): void { }

  /**
   * Sets the value of the selected data type
   */
  public setSelectedDataType(event): void {
    this.selectedDataType = event.target.value;
  }

  /**
   * Downloads the template file
   */
  public downloadLink(): void {
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.download = `${this.selectedDataType}-template.xlsx`;
    link.href = `assets/template/${this.selectedDataType}-template.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  /**
   * Set the status of the sidebar
   */
  public setIsOpen(status: boolean): void {
    this.isOpen = status;
  }

}
